import { cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    variants: [
        {
            props: { widgetVariant: "startpage" },
            style: {
                padding: 0,
                [`.${simpleWidgetCardClasses.header}`]: {
                    [`>.${cardHeaderClasses.content}`]: {
                        [`.${typographyClasses.root}`]: {
                            fontSize: "1.5rem",
                        },
                    },
                },
                [`.${simpleWidgetCardClasses.card}`]: {
                    background: "none",
                    boxShadow: "none",
                    "&:hover": {
                        borderColor: "transparent",
                    },
                },
            },
        },
    ],
})
